import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";

import { planGetActions } from "@/App/actions";
import { RootState } from "@/App/reducers";
import { PlanTypes } from "@/types";

const selectPlan = createSelector(
  (state: RootState) => state.planGet,
  (planGet) => planGet,
);

export function usePlan(id: string): PlanTypes.Plan {
  const planGet = useSelector(selectPlan);
  const { loading } = planGet;
  const plan = planGet.plan.details;
  const dispatch = useDispatch();

  if (loading || parseInt(id) === plan.id) {
    return plan;
  }

  const { getPlan } = planGetActions;
  dispatch(getPlan(id));

  return plan;
}
